/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
const fixedHeightStyles = css({
  height: `${gridSize() * 18}px`
});
export const EmptyViewWithFixedHeight = ({
  children
}) => jsx("div", {
  css: fixedHeightStyles
}, children);
const emptyViewContainerStyles = css({
  margin: 'auto',
  padding: '10px',
  textAlign: 'center',
  width: '50%'
});
export const EmptyViewContainer = ({
  children
}) => jsx("div", {
  css: emptyViewContainerStyles
}, children);